module.exports = __webpack_public_path__ + "static/media/background.4029b134.jpg";